import script from "./MaisonetteFooter.vue?vue&type=script&setup=true&lang=js"
export * from "./MaisonetteFooter.vue?vue&type=script&setup=true&lang=js"

import "./MaisonetteFooter.vue?vue&type=style&index=0&id=a929f4ca&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a929f4ca"]])

export default __exports__